module.exports = __webpack_public_path__ + "images/_/_/shared/images/ranking/1_350e01e561808f60167c06164d8750c9.png";